import { css } from '@emotion/core'

export const initializeSelectBoxStyle = css({
  appearance: 'none',
  backgroundColor: '#fff',
})
